'use client'

import { useState } from 'react'

type Author = {
  name?: string | null
}

type Props = {
  author?: Author | null
  publishedDate?: string | null
  updatedAt?: string
}

function formatDateTime(date: string) {
  return new Date(date).toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC',
  }) + ' UTC'
}

export default function ArticleByline({ author, publishedDate, updatedAt }: Props) {
  const [showTooltip, setShowTooltip] = useState(false)

  const wasUpdated = publishedDate && updatedAt &&
  new Date(updatedAt).getTime() - new Date(publishedDate).getTime() > 86400000

  return (
    <div className="flex flex-wrap items-center gap-2 text-xs lg:text-sm text-zinc-600 mb-0 pb-4">
      {author?.name && (
        <span className="font-semibold text-zinc-700">{author.name}</span>
      )}
      {author?.name && publishedDate && <span>•</span>}
      {publishedDate && <span>{formatDateTime(publishedDate)}</span>}
      {wasUpdated && updatedAt && (
        <div className="relative flex items-center cursor-pointer" onClick={() => setShowTooltip(!showTooltip)}>
          <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 ml-1 text-zinc-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
          <div className={`absolute bottom-full right-0 lg:right-auto lg:left-0 mb-1 px-2 py-1 bg-zinc-800 text-white text-xs rounded whitespace-nowrap z-10 transition-opacity ${showTooltip ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
            Updated on {formatDateTime(updatedAt)}
          </div>
        </div>
      )}
    </div>
  )
}